import {AppRegistry} from 'react-native';
import name from './app.json';
import App from './App';
import {theme} from './src/theme';

/** DOM shell before RN paints — must match `index.html` body background (see docs/THEMING.md). */
if (typeof document !== 'undefined') {
  const shellBg = theme.colors.backgroundSignInWeb;
  document.documentElement.style.backgroundColor = shellBg;
  document.body.style.backgroundColor = shellBg;
}

const generateFont = (iconFont, fontName) => {
  const iconFontStyles = `@font-face {
    src: url(${iconFont});
    font-family: ${fontName};
  }`;

  // Create a stylesheet
  const style = document.createElement('style');
  style.type = 'text/css';

  // Append the iconFontStyles to the stylesheet
  if (style.styleSheet) {
    style.styleSheet.cssText = iconFontStyles;
  } else {
    style.appendChild(document.createTextNode(iconFontStyles));
  }

  // Inject the stylesheet into the document head
  document.head.appendChild(style);
};

// These are the fonts the app currently uses
import iconFont1 from './src/assets/fonts/AbbisWayIcons.ttf';
generateFont(iconFont1, 'AbbisWayIcons');

AppRegistry.registerComponent(name, () => App);
AppRegistry.runApplication(name, {
  initialProps: {},
  rootTag: document.getElementById('app-root'),
});
